import { render, staticRenderFns } from "./twoDishonour.vue?vue&type=template&id=5c3d9d56&scoped=true&"
import script from "./twoDishonour.vue?vue&type=script&lang=js&"
export * from "./twoDishonour.vue?vue&type=script&lang=js&"
import style0 from "./twoDishonour.vue?vue&type=style&index=0&id=5c3d9d56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d9d56",
  null
  
)

export default component.exports